<template>
  <div class="rightChart">
    <div class="bottomLeft">
      <!-- 标题 -->
      <div class="mapTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">分省企业数量</div>
      </div>
      <!-- 地图 -->
      <div id="map"></div>
    </div>
    <div class="bottomRight">
      <!-- 标题 -->
      <div class="mapTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">按登记注册类型分企业数量TOP10</div>
      </div>
      <!-- 纵向柱图 -->
      <div id="thin1"></div>
    </div>
    <div class="bottomLeft">
      <!-- 标题 -->
      <div class="mapTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">企业数量按行业分布</div>
      </div>
      <!-- 树图-->
      <div id="tree"></div>
    </div>
    <div class="bottomRight">
      <!-- 标题 -->
      <div class="mapTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">按控股类型分企业数量</div>
      </div>
      <!-- 柱图 -->
      <div id="graph"></div>
      <!-- 标题 -->
      <div class="mapTitle">
        <div class="littleImg">
          <img src="../assets/img/littleImg.png" alt />
        </div>
        <div class="word">按隶属关系分企业数量TOP5</div>
      </div>
      <!-- 柱图 -->
      <div id="graph2"></div>
    </div>
    <!-- 时间线 -->
    <div class="bottom_timeLine">
      <div id="timeLine2"></div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import chinaJson from '../../static/common/china.json';
import echarts from "echarts";

export default {
  data() {
    return {
      xAxis_data: [],
      moveYearsList: [], //时间轴数据
      series_data: [],
      timeLine2: null
    };
  },
  props: ["initEchart"],
  watch: {
    initEchart() {
      this.init();
      this.timeLine2.resize();
    }
  },
  methods: {
    // 中国地图
    map(year) {
      var mapList = [];
      var max = 0,
        min = 0,
        values = [];
      var myMap = echarts.init(document.getElementById("map"));
      myMap.resize();
      api.getIndustryOrRegionMap("region", year).then(res => {
        this.moveYearsList = res.data.moveYearsList;
        if (this.timeLine2 == null) {
          if (res.data.moveYearsList != []) {
            this.time(res.data.moveYearsList); //时间轴
          }
        }
        res.data.data.forEach(item => {
          var newArr = {};
          newArr.name = item.name;
          newArr.value = item.value;
          mapList.push(newArr);
        });
        if (mapList.length > 0) {
          var arr = [];
          mapList.forEach((v, i) => {
            arr.push(v.value);
          });
          max = Math.max(...arr);
          min = Math.min(...arr);
        }
        var optionMap = {
          tooltip: {
            //鼠标移上去时显示悬浮框
            trigger: "item",
            // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
            // padding: 0,
            formatter: "{b}\n{c}家"
          },
          visualMap: {
            //图注
            min: min,
            max: max,
            left: "left",
            top: "bottom",
            text: ["高", "低"],
            inRange: {
              color: ["#87cefa", "#dfed27", "#e6521b"]
            },
            textStyle: {
              color: "#fff",
              fontSize: 12,
              fontWeight: 400
            },
            show: true
          },

          series: [
            //整体配置
            {
              name: "中国",
              type: "map",
              mapType: "china",
              // roam: true,//缩放
              zoom: 1.2,
              label: {
                normal: {
                  show: true //省份名称
                }
              },
              data: mapList
            }
          ]
        };
        if (optionMap && typeof optionMap === "object") {
          myMap.clear();
          echarts.registerMap("china", chinaJson);
          myMap.setOption(optionMap);
          window.onresize = myMap.resize;
        }
      });
    },
    //   折线图
    thin1(year) {
      var thin1 = echarts.init(document.getElementById("thin1"));
      thin1.resize();
      api.getIndustryOrRegionMap("company_type", year).then(res => {
        let _data = res.data.data.slice(0, 10);
        _data.sort((a, b) => {
          return a.value - b.value;
        });
        option.series[0].data = _data;
        let tmpData = [];
        if (_data.length > 0) {
          for (let i = 0; i < _data.length; i++) {
            tmpData.push(_data[i].name);
          }
          option.yAxis[0].data = tmpData;
        }
        if (option && typeof option === "object") {
          thin1.setOption(option);
          window.onresize = thin1.resize;
        }
      });
      let option = {
        color: ["#1C83E8"],
        tooltip: {
          trigger: "item",
          // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
          // padding: 0,
          formatter: "{b}：\n{c}家"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        yAxis: [
          {
            axisLine: { show: false }, //去掉线
            axisTick: { show: false }, //去掉点
            type: "category",
            data: [],
            axisLabel: {
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        xAxis: [
          {
            type: "value",
            show: false
          }
        ],
        series: [
          {
            name: "",
            type: "bar",
            barWidth: "30%",
            radius: "2px",
            data: [],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#DFECF7",
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      };
    },
    tree(year) {
      let myTree = echarts.init(document.getElementById("tree"));
      myTree.resize();
      let option = {
        tooltip: {
          trigger: "item",
          // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
          // padding: 0,
          formatter: "{b}：\n{c}家"
        },
        visualMap: {
          show: false,
          min: 0,
          max: 70,

          textStyle: {
            color: "#333",
            fontSize: 14,
            align: "right"
          },
          inRange: {
            color: [
              "#3B8CDB",
              "#8EC2F5",
              "#035CB2",
              "#0365C4",
              "#0D6CC9",
              "#2782DB",
              "#1B79D5"
            ] //
          }
        },
        series: [
          {
            type: "treemap",
            width: "100%",
            height: "90%",
            roam: false, //是否开启拖拽漫游（移动和缩放）
            // nodeClick: true, //点击节点后的行为,false无反应
            breadcrumb: {
              show: false
            },
            label: {
              //描述了每个矩形中，文本标签的样式。
              normal: {
                show: true,
                position: ["10%", "40%"]
              }
            },
            normal: {
              show: true,
              textStyle: {
                color: "#fff",
                fontSize: 14
              },
              borderWidth: 1,
              borderColor: "transparent"
            }
          }
        ]
      };
      api.getIndustryOrRegionMap("industry", year).then(res => {
        let _data = res.data.data;
        option.series[0].data = _data;
        if (option && typeof option === "object") {
          myTree.setOption(option);
          window.onresize = myTree.resize;
        }
      });
    },
    graph(year) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph = echarts.init(document.getElementById("graph"));
      myGraph.resize();
      api.getIndustryOrRegionMap("kgtype", year).then(res => {
        let _data = res.data.data;
        _data.forEach((v, i) => {
          xAxis_data.push(v.name);
          series_data.push(v.value);
        });
        var option = {
          color: ["#1C83E8"],
          tooltip: {
            trigger: "item",
            // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
            // padding: 0,
            formatter: "{b}\n{c}家"
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              data: xAxis_data,
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                interval: 0,
                textStyle: {
                  color: "#fff"
                }
              }
            }
          ],
          yAxis: [
            {
              type: "value",
              axisLabel: {
                textStyle: {
                  color: "#fff"
                }
              }
            }
          ],
          series: [
            {
              type: "bar",
              barWidth: "60%",
              data: series_data,
              itemStyle: {}
            }
          ]
        };
        myGraph.setOption(option);
      });
    },
    graph2(year) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph2 = echarts.init(document.getElementById("graph2"));
      myGraph2.resize();
      api.getIndustryOrRegionMap("relationtype", year).then(res => {
        let _data = res.data.data.slice(0, 5);
        _data.forEach((v, i) => {
          xAxis_data.push(v.name);
          series_data.push(v.value);
        });
        var option = {
          color: ["#1C83E8"],
          tooltip: {
            trigger: "item",
            // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
            // padding: 0,
            formatter: "{b}\n{c}家"
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              data: xAxis_data,
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                interval: 0,
                textStyle: {
                  color: "#fff"
                }
              }
            }
          ],
          yAxis: [
            {
              type: "value",
              axisLabel: {
                textStyle: {
                  color: "#fff"
                }
              }
            }
          ],
          series: [
            {
              type: "bar",
              barWidth: "60%",
              data: series_data
            }
          ]
        };
        myGraph2.setOption(option);
      });
    },
    time(moveYearsList) {
      this.timeLine2 = echarts.init(document.getElementById("timeLine2"));
      let option = {
        timeline: {
          data: moveYearsList,
          axisType: "category",
          autoPlay: false,
          playInterval: 3000,
          left: "0",
          right: "0",
          bottom: "5%",
          width: "100%",
          //  height: null,
          label: {
            normal: {
              textStyle: {
                color: "#ddd"
              }
            },
            emphasis: {
              textStyle: {
                color: "#fff"
              }
            }
          },
          symbolSize: 10,
          lineStyle: {
            color: "#555"
          },
          checkpointStyle: {
            borderColor: "#777",
            borderWidth: 2
          },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: {
              color: "#666",
              borderColor: "#666"
            },
            emphasis: {
              color: "#aaa",
              borderColor: "#aaa"
            }
          }
        }
      };
      this.timeLine2.setOption(option);
      this.timeLine2.on("timelinechanged", v => {
        let time = moveYearsList[v.currentIndex];
        time = time.substr(0, time.length - 1);
        this.map(time); //地图
        this.thin1(time); //折线图1
        this.tree(time); //树图
        this.graph(time); //柱图
        this.graph2(time); //柱图
      });
    },
    init() {
      api.getIndustrialDimensions().then(res => {
        let year = res.data.time[0].slice(0, 4);
        this.map(year); //地图
        this.thin1(year); //折线图1
        this.tree(year); //树图
        this.graph(year); //柱图
        this.graph2(year); //柱图
      });
    }
  },
  beforeDestroy() {
    if (!this.timeLine2) {
      return;
    }
    this.timeLine2.dispose();
    this.timeLine2 = null;
  },
  mounted() {
    this.init();
  }
};
</script>
<style scoped lang="less">
/* scrollbar */
.rightChart::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
.rightChart::-webkit-scrollbar-thumb {
  background: #3583ed;
  border-radius: 5px;
}
.rightChart::-webkit-scrollbar-track {
  background: #dfdfdf;
  border-radius: 5px;
}
/* 针对IE的scrollbar */
.rightChart {
  scrollbar-face-color: #3583ed; /*3D表面（ThreedFace）*/
  scrollbar-highlight-color: #dfdfdf; /*3D界面的亮边（ThreedHighlight）*/
  scrollbar-shadow-color: #dfdfdf; /*3D界面的暗边（ThreedShadow）*/
  scrollbar-3dlight-color: #dfdfdf; /*亮边框*/
  scrollbar-arrow-color: #3583ed; /*方向箭头 */
  scrollbar-track-color: #dfdfdf; /*拖动区域(TrackBar)*/
  scrollbar-darkshadow-color: #dfdfdf; /*暗边框（ThreedDarkShadow）*/
}
/* 针对firefox的scrollbar */
.rightChart {
  scrollbar-color: #3583ed #dfdfdf;
  scrollbar-width: thin;
}
/* Edge 的scrollbar隐藏*/
/* .rightChart{
    -ms-overflow-style:none;
} */
// 可视化
.rightChart {
  width: auto;
  height: auto;
  margin-right: 20px;
  padding: 20px 20px 50px 20px;
  background: rgba(5, 43, 79, 0.3);
  border: 1px solid #08396a;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  // overflow-x: scroll;
  .bottomLeft {
    width: 50%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-right: 50px;
    //  标题
    .mapTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #08396a;
      .littleImg {
        img {
          width: 12px;
          height: 12px;
        }
      }

      .word {
        margin-left: 4px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #dfecf7;
      }
    }
    #map,
    #tree {
      width: 100%;
      height: 603px;
      margin: 0 auto;
      overflow: hidden;
    }
  }
  .bottomRight {
    width: 46%;
    height: auto;
    display: flex;
    flex-direction: column;
    //  标题
    .mapTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #08396a;
      .littleImg {
        img {
          width: 12px;
          height: 12px;
        }
      }

      .word {
        margin-left: 4px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #dfecf7;
      }
    }
    #thin1 {
      width: 100%;
      height: 603px;
      margin: 0 auto;
      overflow: hidden;
    }
    #graph,
    #graph2 {
      width: 100%;
      height: 300px;
      margin: 0 auto;
      overflow: hidden;
    }
  }
  .bottom_timeLine {
    width: 100%;
    height: 100px;
    margin-top: 20px;
    #timeLine2 {
      width: 100%;
      height: 100px;
      margin: 0 auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/chart2.vue